import React, {ChangeEvent, Component, ReactNode} from 'react'
import RRFFFacilityInformation from './ResidentReserveFacilityFormComponents/RRFFFacilityInformation'
import RRFFReservePaymentView from './ResidentReserveFacilityFormComponents/RRFFReservePaymentView'
import RRFFReserveOptionInput, {FacilityOption} from './ResidentReserveFacilityFormComponents/RRFFReserveOptionInput'
import {Nullable} from '../../app/TypeHelpers'
import RRFFReserveUsersRoomNumberInput from './ResidentReserveFacilityFormComponents/RRFFReserveUsersRoomNumberInput'
import {
    ACCESS_CONTROL_MANAGER,
    AVAILABLE_OR_NOT,
    CHARGE_UNIT,
    FACILITY_CATEGORY,
    HOURS,
    RESERVATION_ACCEPTABILITY_FOR_RESIDENT,
    RESERVATION_TIME_UNIT_MINUTES,
} from '../../CodeMaster'
import {ReservationOption, ReserveFacilityModel} from './ReserveFacilityModel'
import FacilityForReservation, {FacilityInformation} from '../facilities/FacilityForReservation'
import {formatNumberWithCommas} from '../../formatters/formatNumberWithCommas'
import FacilitiesRepository from '../facilities/FacilitiesRepository'
import HolidaysRepository from '../HolidaysRepository'
import moment from 'moment'
import EventEmitterExResident from '../shared/pageBaseComponents/EventEmitterExResident'
import RRFFReserveAvailabilityView from './ResidentReserveFacilityFormComponents/RRFFReserveAvailabilityView'
import RRFFReserveDataInputOvernightFacility
    from './ResidentReserveFacilityFormComponents/RRFFReserveDataInputOvernightFacility'
import RRFFReserveDataInputDurationFacility
    from './ResidentReserveFacilityFormComponents/RRFFReserveDataInputDurationFacility'
import ReserveAvailabilityListOvernight from './ReserveAvailabilityOvernight'
import ReserveAvailabilityListDuration from './ReserveAvailabilityDuration'
import ReservationsRepository from './ReservationsRepository'
import RRFFReservationTypeView from './ResidentReserveFacilityFormComponents/RRFFReservationTypeView'
import {
    DisplayItem,
    DisplayItemDivider,
    DisplayItemInput,
    DisplayItemInputTitleNoMargin,
    DisplayItemLabelDivNoMargin,
    DisplayItemTitle,
} from '../../styledComponents/DisplayItem'
import {SelectedUser} from '../../__NoAutomatedTests/components/common/resident/NatResidentSelectedUser'
import NatRoomNumberRepo from '../../__NoAutomatedTests/components/roomNumber/repository/NatRoomNumberRepo'
import NatRidgeRepo from '../../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import {ErrorResponseBody} from '../../network/response/ErrorResponseBody'
import RRFFErrorInformation from './ResidentReserveFacilityFormComponents/RRFFErrorInformation'
import {RequestError} from '../../network/response/RequestError'
import {RequestItemError} from '../../network/response/RequestItemError'
import {getYearAfterNextDateFac, NatAsyncCallFunction} from '../../__NoAutomatedTests/common/util/Natutil'
import {formatDateLocal} from '../../formatters/formatMoment'
import {Box} from '@mui/material'
import {
    BlockSpacer,
    BlockSpacerSpOnly,
    GridBlockSpacer,
    GridContainer,
    GridItem,
    LabeledGridContainer,
} from '../../styledComponents/ResponsiveConvenience'
import {RowFlexContainer} from '../../styledComponents/FlexComponents'
import {Colors} from '../../styledComponents/Constants'
import styled from 'styled-components'
import {convertToMoment, durationString, judgeFacilityReserveEditAuthority} from './helpers/helpers'
import {COMMON_CONSTANTS} from '../../CommonConstants'
import {ViewOnlyModeMessage} from './components/CommonStyle'
import {Messages} from '../../Messages'
import Scroll from 'react-scroll'
import NatCurrentDateTimeRepo
    from '../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import {formatForDateInput} from '../../formatters/formatDate'
import {NavigateFunction} from 'react-router-dom'

interface Props {
    facilitiesRepo: FacilitiesRepository
    reservationsRepo: ReservationsRepository
    holidaysRepo: HolidaysRepository
    reservationModel: ReserveFacilityModel
    eventEmitter: EventEmitterExResident
    roomNumberRepo: NatRoomNumberRepo
    ridgeRepo: NatRidgeRepo

    condominiumCd: string
    facilityId: number

    reservationStartDate: Nullable<string>
    reservationStartTime: Nullable<string>
    reservationEndDate: Nullable<string>
    reservationEndTime: Nullable<string>
    reservationStayCount: Nullable<number>
    reservationId: Nullable<number>

    reservationTitle: Nullable<string>
    sharedUseRoomNumberList: SelectedUser[]
    reservationOptions: ReservationOption[]

    navigate: NavigateFunction
    errorResponseBody: Nullable<ErrorResponseBody>

    renderSubmitButton?: () => ReactNode
    currentDateTimeRepo: NatCurrentDateTimeRepo
}

interface State {
    isLoadComplete: boolean
    facilityInformation: FacilityInformation
    facilityOptions: Nullable<FacilityOption[]>
    stayAvailable: Nullable<boolean>
    holidays: string[]

    searchDate: string
    reserveStartDate: string

    reservationTitle: string
    accessControlManager: Nullable<ACCESS_CONTROL_MANAGER>

    reserveAvailabilityForOvernightRentalFacility: Nullable<ReserveAvailabilityListOvernight>
    reserveAvailabilityForDurationFacility: Nullable<ReserveAvailabilityListOvernight>

    durationStringForDisplay: string

    titleChangedAfterError: boolean
    dateChangedAfterError: boolean
    agentOnlyMode: boolean
    viewOnlyMode: boolean
    currentDateTime: Nullable<moment.Moment>
}

class ResidentReserveFacilityForm extends Component<Props, State> {

    private errorDispRef: React.RefObject<HTMLDivElement>

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            isLoadComplete: false,
            titleChangedAfterError: false,
            dateChangedAfterError: false,
            searchDate: '',
            reserveStartDate: '',

            facilityInformation: {
                facilityName: '',
                facilityCategory: FACILITY_CATEGORY.OTHER,
                lotteryAvailability: AVAILABLE_OR_NOT.UNAVAILABLE,
                facilityIntroductory: '',
                facilityImages: [],
                overnightSetting: null,
                durationSetting: null,
                lotterySetting: {
                    facilityReserveLotteryStart: null,
                    facilityReserveLotteryEnd: null,
                    facilityReserveConfirmLimit: null,
                    facilityReserveLotteryMonth: null,
                    facilityReserveFasterPeriod: null,
                },
            },
            reservationTitle: '',
            facilityOptions: null,
            accessControlManager: null,
            stayAvailable: null,
            holidays: [],

            reserveAvailabilityForOvernightRentalFacility: null,
            reserveAvailabilityForDurationFacility: null,

            durationStringForDisplay: COMMON_CONSTANTS.INVALID_CALCULATE_RESULT,
            agentOnlyMode: false,
            viewOnlyMode: false,
            currentDateTime: null,
        }

        this.errorDispRef = React.createRef()

        this.handleChangeTargetDate = this.handleChangeTargetDate.bind(this)
        this.handleChangeReserveStartDate = this.handleChangeReserveStartDate.bind(this)
        this.handleChangeDuration = this.handleChangeDuration.bind(this)
        this.handleChangeReservationTitle = this.handleChangeReservationTitle.bind(this)
        this.handleChangeReserveAvailabilitiesOvernight = this.handleChangeReserveAvailabilitiesOvernight.bind(this)
        this.handleChangeReserveAvailabilitiesDuration = this.handleChangeReserveAvailabilitiesDuration.bind(this)
    }

    componentWillUnmount(): void {
        this.props.reservationModel.reset()
    }

    async componentDidMount(): Promise<void> {
        let viewOnlyMode: boolean = false
        try {
            viewOnlyMode = !judgeFacilityReserveEditAuthority()
        } catch (e) {
            this.props.navigate(`/resident/error`, {state: {message: Messages.ESYCC0025.toString()}})
            return
        }

        const {reservationModel, reservationStartDate} = this.props

        try {
            await this.props.eventEmitter.showLoading()

            const facilityData: Nullable<FacilityForReservation> = await this.getFacilityForReservation()
            if (facilityData === null) {
                return
            }

            const facilityOptions: FacilityOption[] = this.extractFacilityOptions(facilityData)

            const currentDateTime: Nullable<moment.Moment> = await this.getCurrentDate()
            if (currentDateTime === null) {
                return
            }
            const holidays: Nullable<string[]> = await this.getHolidays(currentDateTime)

            let reserveTitle: string = ''
            if (this.props.reservationTitle !== null) {
                reserveTitle = this.props.reservationTitle
            }

            let agentOnlyMode: boolean = false
            if (facilityData.residentReserve.value === RESERVATION_ACCEPTABILITY_FOR_RESIDENT.AGENT.value) {
                agentOnlyMode = true
            }

            const startDate: string = reservationStartDate || this.getDateString(currentDateTime)
            this.setState({
                searchDate: startDate,
                reserveStartDate: startDate,
                facilityInformation: {
                    facilityName: facilityData.facilityName,
                    facilityCategory: facilityData.facilityCategory,
                    lotteryAvailability: facilityData.lotteryAvailability,
                    facilityIntroductory: facilityData.facilityIntroductory,
                    facilityImages: facilityData.facilityImages,
                    overnightSetting: facilityData.overnightFacilitySetting,
                    durationSetting: facilityData.durationFacilitySetting,
                    lotterySetting: facilityData.lotterySetting,
                },
                facilityOptions: facilityOptions,
                stayAvailable: facilityData.stayAvailability,
                holidays: holidays === null ? [] : holidays,
                accessControlManager: facilityData.accessControlManager,
                reservationTitle: reserveTitle,
                agentOnlyMode: agentOnlyMode,
                viewOnlyMode: viewOnlyMode,
                currentDateTime: currentDateTime,
            }, () => {
                reservationModel
                    .withReservationTitle(reserveTitle)
                    .withHolidays(holidays)
                    .withFacilityData(facilityData)

                this.setState({
                    isLoadComplete: true,
                })
            })

        } finally {
            this.props.eventEmitter.closeLoading()
            this.scrollIfError()
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (this.props.errorResponseBody &&
            prevProps.errorResponseBody !== this.props.errorResponseBody) {
            this.setState({
                titleChangedAfterError: false,
                dateChangedAfterError: false,
            }, () => this.scrollIfError())
        }
    }

    scrollIfError(): void {
        if (this.props.errorResponseBody && this.props.errorResponseBody.requestError) {
            if (this.errorDispRef.current) {
                Scroll.animateScroll.scrollTo(this.errorDispRef.current.offsetTop, {
                    delay: 100,
                    duration: 500,
                    smooth: true,
                })
            }
        }
    }

    async getCurrentDate(): Promise<Nullable<moment.Moment>> {
        const {currentDateTimeRepo, navigate} = this.props
        let currentDate: Nullable<moment.Moment>
        const currentTimeResponse = await NatAsyncCallFunction(
            currentDateTimeRepo.getCurrentDateTime.bind(currentDateTimeRepo),
            navigate,
        )
        if (currentTimeResponse === null || currentTimeResponse.details === null) {
            return null
        }
        currentDate = moment(currentTimeResponse.details.currentDateTime)
        return currentDate
    }

    async getHolidays(today: moment.Moment): Promise<Nullable<string[]>> {
        try {
            return await NatAsyncCallFunction(
                this.props.holidaysRepo.getHolidays.bind(
                    this.props.holidaysRepo,
                    this.getDateString(today),
                    formatForDateInput(getYearAfterNextDateFac(today.toLocaleString())),
                ),
                this.props.navigate,
            )
        } catch (e) {
            throw e
        }
    }

    getDateString(date: moment.Moment): string {
        return formatDateLocal(date)
    }


    async getFacilityForReservation(): Promise<Nullable<FacilityForReservation>> {
        try {
            return await NatAsyncCallFunction(
                this.props.facilitiesRepo.getFacilityForReservation.bind(
                    this.props.facilitiesRepo,
                    this.props.condominiumCd,
                    this.props.facilityId,
                )
                , this.props.navigate,
            )
        } catch (e) {
            throw e
        }
    }

    extractFacilityOptions(facilityData: FacilityForReservation): FacilityOption[] {
        return facilityData.facilityOptions.map(option => {
            const outlineCharge = `${formatNumberWithCommas(option.charge)}円`
            const outlineUnit = ` / 1${option.unitName}`
            const outlineUnitTime = (option.chargeUnit !== CHARGE_UNIT.FIXED)
                ? ` (${option.chargeUnitTime}${option.chargeUnit.label}あたり)`
                : ''
            const outline = outlineCharge + outlineUnitTime + outlineUnit

            return {
                optionId: option.optionId,
                optionName: option.name,
                outline: outline,
                minimumQuantity: option.volumeMin,
                maximumQuantity: option.volumeMax,
                quantity: 0,
                unit: option.unitName,
                required: option.appointRequired,
                sortOrder: option.sortOrder,
            }
        })
    }

    handleChangeReservationTitle(event: ChangeEvent<HTMLInputElement>): void {
        const newTitle = event.target.value
        this.setState(
            {
                reservationTitle: newTitle,
                titleChangedAfterError: true,
            },
            () => this.props.reservationModel.withReservationTitle(newTitle),
        )
    }

    handleChangeTargetDate(targetDate: string): void {
        this.setState({searchDate: targetDate})
    }

    handleChangeReserveStartDate(targetDate: string): void {
        this.setState({
            reserveStartDate: targetDate,
            dateChangedAfterError: true,
        })
    }

    handleChangeDuration(
        startDate: string,
        startHour: Nullable<HOURS>,
        startMinute: Nullable<RESERVATION_TIME_UNIT_MINUTES>,
        endDate: Nullable<string>,
        endHour: Nullable<HOURS>,
        endMinute: Nullable<RESERVATION_TIME_UNIT_MINUTES>,
    ): void {
        this.setState({
            reserveStartDate: startDate,
            dateChangedAfterError: true,
        })

        if (startHour === null || startMinute === null
            || endDate === null || endHour === null || endMinute === null) {
            this.setState({durationStringForDisplay: COMMON_CONSTANTS.INVALID_CALCULATE_RESULT})
            return
        }
        const startDateTime =
            convertToMoment(startDate, `${startHour.value}:${startMinute.value}`)
        const endDateTime =
            convertToMoment(endDate, `${endHour.value}:${endMinute.value}`)
        const displayDurationString = durationString(startDateTime, endDateTime)
        this.setState({durationStringForDisplay: displayDurationString})
    }

    handleChangeReserveAvailabilitiesOvernight(data: ReserveAvailabilityListOvernight): void {
        this.props.reservationModel.withOvernightReserveAvailableData(data.reserveAvailableList)
    }

    handleChangeReserveAvailabilitiesDuration(data: ReserveAvailabilityListDuration): void {
        this.props.reservationModel.withDurationReserveAvailableData(data.reserveAvailableList)
    }

    render(): ReactNode {
        const {
            facilityInformation, reservationTitle, facilityOptions, accessControlManager, stayAvailable,
            currentDateTime, agentOnlyMode, viewOnlyMode, searchDate, holidays, reserveStartDate,
            durationStringForDisplay,
        } = this.state
        const {
            reservationOptions, errorResponseBody, condominiumCd, facilityId, reservationId, reservationsRepo,
            eventEmitter, navigate, reservationStayCount, reservationModel, reservationStartTime, reservationEndDate,
            reservationEndTime, roomNumberRepo, ridgeRepo, renderSubmitButton, sharedUseRoomNumberList,
        } = this.props
        let requestError: Nullable<RequestError> = null
        let requestOtherErrors: Nullable<RequestItemError[]> = null
        let requestEndDateErrors: Nullable<RequestItemError[]> = null
        let requestReservationTitleErrors: Nullable<RequestItemError[]> = null
        let reservationTitleHasError: boolean = false
        let startDateHasError: boolean = false

        if (errorResponseBody !== null) {
            const {requestItemErrors} = errorResponseBody
            requestError = errorResponseBody.requestError
            requestOtherErrors = requestItemErrors.filter(item => item.resultCode !== 'endDate')
            requestEndDateErrors = requestItemErrors.filter(item => item.resultCode === 'endDate')
            requestReservationTitleErrors = requestItemErrors.filter(item => item.resultCode === 'reservationTitle' ||
            item.fields === undefined ? false : item.fields.includes('reservationTitle'))
            if (requestReservationTitleErrors.length > 0 && (!this.state.titleChangedAfterError)) {
                reservationTitleHasError = true
            }
            if ((requestError !== null) && (requestItemErrors.length === 0) && (!this.state.dateChangedAfterError)) {
                startDateHasError = true
            }
        }
        if (currentDateTime === null) {
            return null
        }

        if (!this.state.isLoadComplete) {
            return null
        }

        return (
            <>
                {
                    agentOnlyMode && <>
                        <ViewOnlyModeMessage>{Messages.IRESR0010.toString()}</ViewOnlyModeMessage>
                        <BlockSpacer height={'20px'}/>
                    </>
                }
                {
                    (!agentOnlyMode && viewOnlyMode) && <>
                        <ViewOnlyModeMessage>{Messages.IRESR0009.toString()}</ViewOnlyModeMessage>
                        <BlockSpacer height={'20px'}/>
                    </>
                }
                <RRFFFacilityInformation
                    openFacilityIntroductory={false}
                    {...facilityInformation}
                />

                <BlockSpacer height={'20px'}/>
                <RRFFReserveAvailabilityView
                    condominiumCd={condominiumCd}
                    facilityId={facilityId}
                    facilityName={facilityInformation.facilityName}
                    reservationId={reservationId}
                    stayAvailable={stayAvailable}
                    reservationsRepo={reservationsRepo}
                    eventEmitter={eventEmitter}
                    targetDate={searchDate}
                    onChangeDate={this.handleChangeTargetDate}
                    onChangeReserveAvailabilityOvernight={this.handleChangeReserveAvailabilitiesOvernight}
                    onChangeReserveAvailabilityDuration={this.handleChangeReserveAvailabilitiesDuration}
                    navigate={navigate}
                    currentDateTime={currentDateTime}
                    holidays={holidays}
                />
                <BlockSpacer height={'20px'}/>
                {(!agentOnlyMode && !viewOnlyMode) && <>
                    <DisplayItem>
                        <DisplayItemTitle ref={this.errorDispRef}>この施設を予約する</DisplayItemTitle>
                        <RRFFErrorInformation
                            requestError={requestError}
                            requestItemErrors={requestOtherErrors}
                        />
                        <BlockSpacer height={'20px'}/>
                        {
                            stayAvailable !== null &&
                            stayAvailable
                                ? facilityInformation.overnightSetting &&
                                <RRFFReserveDataInputOvernightFacility
                                    defaultStartDate={reserveStartDate}
                                    defaultStayCount={reservationStayCount}
                                    facilityData={facilityInformation.overnightSetting}
                                    reservationModel={reservationModel}
                                    currentDateTime={currentDateTime}
                                    hasError={startDateHasError}
                                    onChange={this.handleChangeReserveStartDate}
                                    holidays={holidays}
                                />
                                : facilityInformation.durationSetting &&
                                <RRFFReserveDataInputDurationFacility
                                    defaultStartDate={reserveStartDate}
                                    defaultStartTime={reservationStartTime}
                                    defaultEndDate={reservationEndDate || reserveStartDate}
                                    defaultEndTime={reservationEndTime}
                                    reservationModel={reservationModel}
                                    currentDateTime={currentDateTime}
                                    onChange={this.handleChangeDuration}
                                    hasError={startDateHasError}
                                    requestItemErrors={requestEndDateErrors}
                                    holidays={holidays}
                                />
                        }
                        <GridContainer>
                            <GridBlockSpacer height={'20px'}/>
                            {
                                !stayAvailable &&
                                <>
                                    <GridItem over={3}/>
                                    <GridItem over={9}>
                                        <StyledRowFlexContainer>
                                            <Box my={'10px'} ml={'15px'}>
                                                <DisplayItemLabelDivNoMargin>利用時間</DisplayItemLabelDivNoMargin>
                                            </Box>
                                            <Box my={'10px'} mr={'15px'}>
                                                <DisplayItemLabelDivNoMargin>
                                                    {durationStringForDisplay}
                                                </DisplayItemLabelDivNoMargin>
                                            </Box>
                                        </StyledRowFlexContainer>
                                    </GridItem>
                                    <GridBlockSpacer height={'10px'}/>
                                </>
                            }

                            <GridItem over={3}/>
                            <GridItem over={9}>
                                <StyledRowFlexContainer>
                                    <Box my={'10px'} ml={'15px'}>
                                        <DisplayItemLabelDivNoMargin>予約種別</DisplayItemLabelDivNoMargin>
                                    </Box>
                                    <Box my={'10px'} mr={'15px'}>
                                        <DisplayItemLabelDivNoMargin>
                                            <RRFFReservationTypeView
                                                targetDate={reserveStartDate}
                                                currentDateTime={currentDateTime}
                                                lotteryAvailability=
                                                    {facilityInformation.lotteryAvailability}
                                                lotterySetting={facilityInformation.lotterySetting}
                                                reservationModel={reservationModel}
                                            />
                                        </DisplayItemLabelDivNoMargin>
                                    </Box>
                                </StyledRowFlexContainer>
                            </GridItem>
                            <GridBlockSpacer height={'20px'}/>
                        </GridContainer>

                        <LabeledGridContainer>
                            <GridItem over={3}>
                                <DisplayItemInputTitleNoMargin>予約タイトル</DisplayItemInputTitleNoMargin>
                            </GridItem>
                            <GridItem over={9}>
                                <BlockSpacerSpOnly height={'10px'}/>
                                <DisplayItemInput
                                    type={'text'}
                                    placeholder={'利用目的を入力してください'}
                                    minLength={0}
                                    maxLength={30}
                                    value={reservationTitle}
                                    onChange={this.handleChangeReservationTitle}
                                    hasError={reservationTitleHasError}
                                />
                            </GridItem>
                        </LabeledGridContainer>
                        {
                            (accessControlManager !== null &&
                                accessControlManager !== ACCESS_CONTROL_MANAGER.RIKB) &&
                            <RRFFReserveUsersRoomNumberInput
                                roomNumberRepo={roomNumberRepo}
                                ridgeRepo={ridgeRepo}
                                eventEmitter={eventEmitter}
                                sharedUseRoomNumberList={sharedUseRoomNumberList}
                                reservationModel={reservationModel}
                                navigate={navigate}
                                validPeriodCriteriaDate={moment(reserveStartDate)}
                                accessControlManager={accessControlManager}
                            />
                        }

                        {
                            facilityOptions &&
                            <RRFFReserveOptionInput
                                facilityOptions={facilityOptions}
                                reservationOptions={reservationOptions}
                                reservationModel={reservationModel}
                            />
                        }

                        <BlockSpacer height={'30px'}/>
                        <DisplayItemDivider/>
                        <BlockSpacer height={'30px'}/>
                        <RRFFReservePaymentView
                            reservationModel={reservationModel}
                        />
                        <BlockSpacer height={'30px'}/>
                        {
                            renderSubmitButton &&
                            renderSubmitButton()
                        }
                        <BlockSpacer height={'10px'}/>
                    </DisplayItem>
                </>
                }
            </>
        )
    }
}

export default ResidentReserveFacilityForm

const StyledRowFlexContainer = styled(RowFlexContainer)`
  background-color: ${Colors.Background};
`
